import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormEventComponent from '../components/FormEventComponent';
import EventTicketTypesComponent from '../components/EventTicketTypesComponent';
import EventSalonTablesComponent from '../components/EventSalonTablesComponent';
import EventIncludedCard from '../components/EventIncludedCard';
import TournamentCreateModal from '../components/TournamentCreateModal';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { copyLink, eventPublicUrl } from '../utils/publicLinks';
import { getTournamentByEvent, createTournamentForEvent, listTournaments, linkEvent, ESTADO_TORNEO } from '../utils/tournamentsApi';
import TournamentOverlay, { Aviso } from '../components/TournamentOverlay';
import { duplicateEvent } from '../utils/eventsApi';
import { textoDeAviso } from '../utils/activitiesApi';

var config = process.env;

const EVENT_STATUS_LABEL = {
    draft: 'Borrador',
    published: 'Publicado',
    closed: 'Cerrado',
    cancelled: 'Cancelado',
};

class EditEventPage extends Component {
    constructor() {
        super();
        this.state = {
            checked: false, role: 0, id: null, event: null, disabled: false,
            tournament: null, creandoTorneo: false,
            eligiendoTorneo: null, torneoElegido: '', enganchando: false, errorTorneo: null,
            // `attendees` viaja HERMANO de `event` en la respuesta del detalle, no adentro.
            attendees: null,
            // Avisos del salón al publicar / reprogramar (TD-18). NO bloquean: el evento se
            // guardó igual y lo que queda es una mesa con una reserva más tarde esa noche.
            activityWarnings: [],
            // El aviso con el que llega el alta de un evento privado cuando el evento quedó
            // creado y la venta de las entradas no.
            privateEventNotice: null,
        };
    }

    async componentDidMount() {
        const role = await validateSession();
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get('id');
        this.setState({ checked: true, role, id, ...this.takeArrivalState() });
        this.fetchEvent(id);
        this.fetchTorneo(id);
    }

    // Con qué llega el alta de un evento privado: el aviso de la venta que no se registró y los
    // avisos del salón al reservar las mesas. Viajan en el estado de la navegación
    // (`navigateTo(..., { state })`) y se muestran UNA vez: se sacan de la entrada del historial
    // apenas se leen. Si quedaran, volver a esta pantalla con «Atrás» después de vender las
    // entradas diría otra vez que no se registraron.
    takeArrivalState = () => {
        const location = this.props.location || {};
        const state = location.state || {};
        const privateEventNotice = state.privateEventNotice || null;
        const activityWarnings = Array.isArray(state.activityWarnings) ? state.activityWarnings : [];
        if (privateEventNotice || activityWarnings.length > 0) {
            navigateTo(`${location.pathname || '/editEvent'}${location.search || ''}`, { replace: true });
        }
        return { privateEventNotice, activityWarnings };
    }

    // Sólo mostrador (`counter_only`): el evento nació del alta de eventos privados. La web no lo
    // abre ni lo vende, así que su link público no lleva a ningún lado.
    isCounterOnly = () => !!(this.state.event && Number(this.state.event.counter_only));

    // Devuelve una promesa que dice si el evento se pudo volver a leer: quien guarda algo y pide
    // el refresco (los tipos de entrada) retiene lo guardado hasta saber que props ya lo trae.
    // Sólo se aplica la respuesta del ÚLTIMO pedido: una vieja que llega tarde no pisa una nueva.
    fetchEvent = (id) => {
        const seq = (this.fetchEventSeq = (this.fetchEventSeq || 0) + 1);
        const request = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
        };
        this.lastFetchEvent = fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `manage-events/${id}`, request)
            .then((results) => results.json())
            .then((data) => {
                // Hay un pedido más nuevo: vale lo que diga ése.
                if (seq !== this.fetchEventSeq) return this.lastFetchEvent;
                if (data.error > 0) {
                    // ENI-210: el motivo puntual viene en data.data.message; el de arriba es el
                    // genérico por código, y para el 4000 dice "La compra no existe".
                    alert((data.data && data.data.message) || data.message);
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    return false;
                }
                // El backend devuelve { data: { event, attendees } }: `attendees` es hermano
                // de `event`, y la actividad de la jornada va ADENTRO y plana (`event.activity`).
                this.setState({ event: data.data.event, attendees: data.data.attendees || null });
                return true;
            })
            .catch((error) => {
                console.error('No se pudo cargar el evento:', error);
                if (seq !== this.fetchEventSeq) return this.lastFetchEvent;
                alert('Error de conexión');
                return false;
            });
        return this.lastFetchEvent;
    }

    patch = (body, { reload = true } = {}) => {
        this.setState({ disabled: true, activityWarnings: [] });
        const request = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'access-token': localStorage.getItem('token'),
            },
            body: JSON.stringify(body),
        };
        return fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + `manage-events/${this.state.id}`, request)
            .then((results) => results.json())
            .then((data) => {
                if (data.error > 0) {
                    // ENI-116: los errores de negocio de eventos vienen anidados en data.data.message
                    // (invalidResponseWithData). Sin esto el admin ve el genérico "Request inválida".
                    //
                    // FR-025: publicar una jornada puede fallar POR EL SALÓN (7304). Ahí `data.data`
                    // es la LISTA de mesas ocupadas ([{label, reason}]) y no tiene `.message`, así
                    // que el texto de arriba queda en "Mesas no disponibles" — que no dice cuáles.
                    const ocupadas = Array.isArray(data.data) ? data.data : [];
                    const motivo = (!ocupadas.length && data.data && data.data.message) || data.message;
                    const detalle = ocupadas.map((m) => `• ${m.label}: ${m.reason}`).join('\n');
                    alert(detalle ? `${motivo}\n\n${detalle}` : motivo);
                    this.setState({ disabled: false });
                    if (data.error == 1002) {
                        window.location.href = localStorage.getItem('homePageURL');
                    }
                    return false;
                }
                // TD-18: `warnings` son avisos del salón ("6-C tiene una reserva a las 21"), no
                // errores: el evento se guardó. Van a un alert de la pantalla y no a un
                // `window.alert`, que se cierra de un Enter y no deja rastro de qué mesa era.
                this.setState({ disabled: false, activityWarnings: (data.data && data.data.warnings) || [] });
                if (reload) {
                    this.fetchEvent(this.state.id);
                }
                return true;
            })
            .catch((error) => {
                console.error('No se pudo actualizar el evento:', error);
                alert('Error de conexión');
                this.setState({ disabled: false });
                return false;
            });
    }

    handleChangeData = (value) => {
        this.patch(value, { reload: false }).then((ok) => {
            if (!ok) return;
            // FR-029: cambiarle la fecha a una jornada MUEVE sus mesas, y eso puede volver con
            // avisos ("6-C tiene una reserva a las 21"). Irse a /events se llevaría puesto el
            // único lugar donde ese aviso se lee, así que con avisos la pantalla se queda.
            if ((this.state.activityWarnings || []).length) {
                this.fetchEvent(this.state.id);
                return;
            }
            navigateTo('/events');
        });
    }

    // Jornadas del club: la misma jornada la semana que viene. La copia nace en borrador con
    // los tipos de entrada del original y se abre para ajustar la fecha y publicar.
    duplicar = () => {
        if (!window.confirm('¿Duplicar este evento? La copia queda en borrador, una semana después, con los mismos tipos de entrada.')) return;
        duplicateEvent(this.state.id)
            // La página no se desmonta al cambiar el query string: se recarga a mano.
            .then((data) => { window.location.href = `/editEvent?id=${data.event.id}`; })
            .catch((e) => alert(e.message));
    }

    // La actividad de salón de esta jornada, o null. Se exige `status` —que el objeto plano
    // del detalle siempre trae— para que un adjunto con otra forma no encienda "Despublicar"
    // con un "Se liberan las undefined mesas" adentro (S-05f).
    activity = () => {
        const act = this.state.event && this.state.event.activity;
        return act && act.status ? act : null;
    }

    changeStatus = (status) => {
        const labels = { draft: 'despublicar', published: 'publicar', closed: 'cerrar', cancelled: 'cancelar' };
        // FR-026: despublicar cancela las reservas de las mesas y deja el plan intacto, así que
        // la confirmación tiene que decir cuántas mesas se sueltan. Con gente ya sentada el
        // backend rechaza (7308) y el alert lo explica.
        const activity = this.activity();
        const extra = status === 'draft' && activity
            ? ` Se liberan las ${activity.tableCount} ${Number(activity.tableCount) === 1 ? 'mesa' : 'mesas'} del salón; el plan se conserva para volver a publicar.`
            : '';
        if (!window.confirm(`¿Seguro que querés ${labels[status]} este evento?${extra}`)) {
            return;
        }
        this.patch({ status });
    }

    // Los avisos del salón que devolvió el último PATCH (publicar / reprogramar). No bloquean:
    // el evento se guardó y esto es lo que el encargado tiene que ir a mirar esa noche.
    renderActivityWarnings = () => {
        const warnings = this.state.activityWarnings || [];
        if (!warnings.length) return null;
        return (
            <div className="alert alert-warning" role="alert">
                <b>El salón avisa:</b>
                <ul className="mb-0 mt-1">
                    {warnings.map((w, i) => (
                        <li key={i}>{textoDeAviso(w)}</li>
                    ))}
                </ul>
            </div>
        );
    }

    renderPrivateEventNotice = () => {
        if (!this.state.privateEventNotice) return null;
        return (
            <div className="alert alert-warning private-event-notice" role="alert">
                {this.state.privateEventNotice}
                <div className="mt-2">
                    <button type="button" className="btn btn-sm btn-white mr-2" onClick={() => navigateTo(`/eventAdmissions?id=${this.state.id}`)}>
                        Ver asistentes
                    </button>
                    <button type="button" className="btn btn-sm btn-white" onClick={() => this.setState({ privateEventNotice: null })}>
                        Entendido
                    </button>
                </div>
            </div>
        );
    }

    renderStatusActions = () => {
        const event = this.state.event;
        if (!event) return null;
        const status = event.status;
        return (
            <div className="card card-small mb-4">
                <div className="card-body d-flex align-items-center">
                    <span className="mr-3"><b>Estado:</b> {EVENT_STATUS_LABEL[status] || status}</span>
                    {status === 'draft' && (
                        <button type="button" className="btn btn-sm btn-accent mr-2" disabled={this.state.disabled} onClick={() => this.changeStatus('published')}>
                            Publicar
                        </button>
                    )}
                    {/* FR-026: "Despublicar" existe SÓLO para una jornada con mesas del salón.
                        Un evento suelto no tiene por qué volver a borrador desde acá —ese botón
                        nunca existió— y ofrecerlo sería superficie nueva sin motivo. */}
                    {status === 'published' && this.activity() && (
                        <button type="button" className="btn btn-sm btn-outline-secondary mr-2" disabled={this.state.disabled} onClick={() => this.changeStatus('draft')}>
                            Despublicar
                        </button>
                    )}
                    {status === 'published' && (
                        <button type="button" className="btn btn-sm btn-outline-secondary mr-2" disabled={this.state.disabled} onClick={() => this.changeStatus('closed')}>
                            Cerrar
                        </button>
                    )}
                    {(status === 'draft' || status === 'published') && (
                        <button type="button" className="btn btn-sm btn-outline-danger" disabled={this.state.disabled} onClick={() => this.changeStatus('cancelled')}>
                            Cancelar
                        </button>
                    )}
                </div>
            </div>
        );
    }

    // Se pregunta al cargar la pantalla y no al apretar el botón: así el botón puede decir qué
    // va a pasar ("Ver torneo" vs "Linkear torneo") en vez de averiguarlo después del click.
    fetchTorneo = async (id) => {
        try {
            const data = await getTournamentByEvent(id);
            this.setState({ tournament: (data && data.tournament) || null });
        } catch (e) {
            this.setState({ tournament: null });   // sin torneo o sin permiso: se ofrece crear
        }
    }

    // "Linkear torneo" ofrece las dos cosas: enganchar un torneo SUELTO que ya exista (armado por
    // separado, con su formato y hasta su lista a mano) o crear uno nuevo desde acá. Los
    // terminados no se ofrecen: su clasificación ya está sellada. Al enganchar, "Traer inscriptos"
    // vincula por nombre a los que ya estaban cargados, así no se duplican.
    abrirLinkear = async () => {
        try {
            const data = await listTournaments();
            const sueltos = ((data && data.tournaments) || []).filter((t) => t.event_id == null && t.status !== 'finished');
            this.setState({ eligiendoTorneo: sueltos, torneoElegido: '', errorTorneo: null });
        } catch (e) {
            this.setState({ eligiendoTorneo: [], errorTorneo: e.message });
        }
    }

    engancharTorneo = async () => {
        if (!this.state.torneoElegido || this.state.enganchando) return;
        this.setState({ enganchando: true, errorTorneo: null });
        try {
            await linkEvent(this.state.torneoElegido, this.state.id);
            navigateTo('/tournament?id=' + this.state.torneoElegido);
        } catch (e) {
            this.setState({ enganchando: false, errorTorneo: e.message });
        }
    }

    renderLinkear() {
        const lista = this.state.eligiendoTorneo;
        return (
            <TournamentOverlay title="Linkear torneo" onClose={() => this.setState({ eligiendoTorneo: null })}>
                {this.state.errorTorneo ? <Aviso tipo="error">{this.state.errorTorneo}</Aviso> : null}
                <label style={{ fontWeight: 500 }}>Enganchar un torneo que ya existe</label>
                {lista.length ? (
                    <div className="d-flex align-items-center flex-wrap" style={{ gap: 8, marginBottom: 6 }}>
                        <select className="form-control" style={{ width: 'auto', maxWidth: 380 }} aria-label="Torneo a enganchar"
                            value={this.state.torneoElegido} onChange={(e) => this.setState({ torneoElegido: e.target.value })}>
                            <option value="">Elegí un torneo suelto…</option>
                            {lista.map((t) => (
                                <option key={t.id} value={t.id}>
                                    {t.title || `Torneo #${t.id}`}{t.game_name ? ` — ${t.game_name}` : ''} · {(ESTADO_TORNEO[t.status] || {}).label || t.status}
                                </option>
                            ))}
                        </select>
                        <button type="button" className="btn btn-accent" disabled={!this.state.torneoElegido || this.state.enganchando}
                            onClick={this.engancharTorneo}>{this.state.enganchando ? 'Enganchando…' : 'Enganchar'}</button>
                    </div>
                ) : (
                    <div className="text-muted" style={{ fontSize: 13, marginBottom: 6 }}>No hay torneos sueltos sin terminar.</div>
                )}
                <div className="text-muted" style={{ fontSize: 12.5, marginBottom: 16 }}>
                    Después, en el torneo, "Traer inscriptos del evento" suma a los que compraron entrada. A los que ya estaban
                    cargados a mano con el mismo nombre se les vincula la entrada en vez de duplicarlos.
                </div>
                <div style={{ borderTop: '1px solid #EDEFF2', paddingTop: 14 }}>
                    <button type="button" className="btn btn-white"
                        onClick={() => this.setState({ eligiendoTorneo: null, creandoTorneo: true })}>
                        Crear un torneo nuevo para este evento
                    </button>
                </div>
            </TournamentOverlay>
        );
    }

    crearTorneo = async (payload) => {
        const creado = await createTournamentForEvent(this.state.id, payload);
        this.setState({ creandoTorneo: false });
        navigateTo('/tournament?id=' + creado.tournament.id);
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        return (
            <div className="container-fluid">
                {this.state.eligiendoTorneo ? this.renderLinkear() : null}
                {this.state.creandoTorneo ? (
                    <TournamentCreateModal
                        titulo="Torneo de este evento"
                        nota={'El torneo queda enganchado a este evento: los participantes salen de los '
                            + 'anotados y el puntaje se lleva desde acá, sin planilla aparte.'}
                        initial={{ title: (this.state.event && this.state.event.title) || '' }}
                        onCancel={() => this.setState({ creandoTorneo: false })}
                        onCreate={this.crearTorneo} />
                ) : null}
                <div className="row">
                    <SidebarComponent itemSelected={33} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                {/* minWidth:0 — el header es un .row de Bootstrap y colapsa contra
                                    los botones; con dos, "Editar evento" quedaba en dos líneas. */}
                                <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                                    <HeaderComponent title="Eventos" subtitle="Editar evento" />
                                </div>
                                {this.state.event && (
                                    <div className="text-nowrap" style={{ flex: '0 0 auto' }}>
                                        <button type="button" className="btn btn-white" onClick={() => navigateTo(`/eventAdmissions?id=${this.state.id}`)}>
                                            Ver asistentes
                                        </button>
                                        {/* El link público de ESTE evento (en una jornada del club,
                                            el de la serie está en la pantalla de la serie). Un
                                            evento sólo mostrador no lo tiene: la web no lo abre. */}
                                        {this.state.event.slug && !this.isCounterOnly() && (
                                            <button type="button" className="btn btn-white ml-2" title={eventPublicUrl(this.state.event.slug)}
                                                onClick={() => copyLink(eventPublicUrl(this.state.event.slug))}>
                                                Copiar link
                                            </button>
                                        )}
                                        <button type="button" className="btn btn-white ml-2" title="Copia en borrador, una semana después" onClick={this.duplicar}>
                                            Duplicar
                                        </button>
                                        {this.state.tournament ? (
                                            <button type="button" className="btn btn-white ml-2"
                                                onClick={() => navigateTo('/tournament?id=' + this.state.tournament.id)}>
                                                Ver torneo
                                            </button>
                                        ) : (
                                            <button type="button" className="btn btn-white ml-2"
                                                onClick={this.abrirLinkear}>
                                                Linkear torneo
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                            {this.renderPrivateEventNotice()}
                            {this.state.event != null ? (
                                <>
                                    {this.renderActivityWarnings()}
                                    {this.isCounterOnly() && (
                                        <p className="mb-3 event-counter-only">
                                            <i className="material-icons mr-1" style={{ fontSize: 16, verticalAlign: 'text-bottom' }}>storefront</i>
                                            Sólo mostrador: no se abre ni se vende por la web.
                                        </p>
                                    )}
                                    {this.renderStatusActions()}
                                    <FormEventComponent
                                        editMode
                                        initial={this.state.event}
                                        onChangeData={this.handleChangeData}
                                        disabled={this.state.disabled}
                                    />
                                    {/* La card se dibuja SIEMPRE, también con `activity: null`:
                                        la primera "Sumar mesa" es justamente la que crea la
                                        actividad (S-03l). Sin actividad ocupa dos líneas y un
                                        botón — cualquier evento puede tomar mesas del salón, no
                                        sólo los que vienen de una serie. */}
                                    <EventSalonTablesComponent
                                        event={this.state.event}
                                        attendees={this.state.attendees}
                                        onRefresh={() => this.fetchEvent(this.state.id)}
                                    />
                                    {/* Sólo se dibuja si el evento declara qué incluye: lo
                                        pactado, lo entregado y el Resultado del evento. */}
                                    <EventIncludedCard event={this.state.event} />
                                    <EventTicketTypesComponent
                                        eventId={this.state.id}
                                        ticketTypes={this.state.event.ticketTypes || []}
                                        onRefresh={() => this.fetchEvent(this.state.id)}
                                    />
                                </>
                            ) : (
                                <div className="card card-small mb-4"><div className="card-body p-4">Cargando…</div></div>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EditEventPage;
